<template>
  <div class="row">
    <div class="col-md-9 offset-2 breadcrumb-class">
        Está en: <span><a href="">Resumen</a></span>
    </div>
  </div>
  <div id="container-title-indicators">
    <div id="title" v-if="title != ''">
      <b>{{ title }}</b>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeTitle',

  props: {
    title: {
      default: '',
      type: String
    }
  }
}
</script>
<style scoped>
a, a:hover {
  color: rgba(168, 200, 79, 0.9);
}
#container-title-indicators {
  cursor: default;
  display: flex;
  flex-flow: row wrap;
  max-width: 100%;
  text-align: center;
  margin-bottom: 0rem;
}
#title {
  color: rgb(131, 155, 36);
  margin-top: 0.5rem;
  font-size: 1.8rem;
  width: 85%;
  font-family: "Ancizar-bold", Helvetica, Arial;
  margin-left: 9rem;
}
@media (max-width: 769px) {
#container-title-indicators {
  margin: 1em 1em 1em;
}
}
</style>